import { render } from "src/website-apps/shared/utils/render";
import { PerformerRoot } from "./root";

render(<PerformerRoot />);
